import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyCKWHVqdIjXS2QHIahkCD5mJo8997upnFw",
  authDomain: "movinity-web-app.firebaseapp.com",
  projectId: "movinity-web-app",
  storageBucket: "movinity-web-app.firebasestorage.app",
  messagingSenderId: "357131101505",
  appId: "1:357131101505:web:63edef75ad464267f4adc0"
};

const app = initializeApp(firebaseConfig);
export const firebaseAuth = getAuth(app);
export const firebaseFirestore = getFirestore(app);
export const firebaseRealTime = getDatabase(app);
export const firebaseStorage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();

// project-357131101505